/** PC-text modifier labels - never mac glyphs. Shared by the readout and the list. */
export const MOD_LABELS: Record<string, string> = { ctrl: "Ctrl", alt: "Alt", shift: "Shift" };

/**
 * The view-edge label for a canonical combo: the empty data value `""` reads as
 * "Base"; a combo reads as its families in PC text, space-separated ("Ctrl Shift").
 */
export function comboLabel(combo: string): string {
  if (!combo) return "Base";
  return combo
    .split("+")
    .map((m) => MOD_LABELS[m] ?? m)
    .join(" ");
}
